<template>
  <v-container class="page-size">
    <v-row>
      <v-col cols="12">
        <v-tabs
          color="#00A99D"
          class="elevation-0"
          v-model="tabsItem"
          show-arrows
          grow
          center-active
        >
          <v-tabs-slider color="#00A99D"></v-tabs-slider>
            <v-tab
              class="tab pb-2"
              v-for="(item, index) in tab"
              :key="index"
              color="#00A99D"
            >
            <v-chip color="#ceefed78" dark v-if="tabsItem == index">
              <img :src="item.image"/>
            </v-chip>
            <v-chip color="#fff" dark v-else>
              <img :src="item.image"/>
            </v-chip>
              <span class="font-16 px-2"> {{ item.title }} </span>
              
            </v-tab></v-tabs>

            <v-tabs-items v-model="tabsItem">
              <!-- ------------------------*** 0 ****------------------------------ -->
              <v-tab-item eager>
                <Map ref="map"/>
              </v-tab-item>
              <!-- ------------------------*** 1 ****------------------------------ -->
              <v-tab-item eager>
                <Record ref="record" />
              </v-tab-item>

              <!-- ------------------------*** 2 ****------------------------------ -->
              <v-tab-item eager>
                <Estimation ref="estimation" />
              </v-tab-item>

              <!-- ------------------------*** 3 ****------------------------------ -->
              <v-tab-item eager>
                <followUp ref="followup" />   
              </v-tab-item>
          </v-tabs-items>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Map from "../HomeVisit/DetailComponentHomeVisit/Detail_Map.vue";
import Record from "../HomeVisit/DetailComponentHomeVisit/Detail_Record.vue";
import Estimation from "../HomeVisit/DetailComponentHomeVisit/Detail_Estimation.vue";
import FollowUp from "../HomeVisit/DetailComponentHomeVisit/Detail_FollowUp.vue";
export default {
  props: { 
    item: Object,
    value: Object,
  },
  components: {
    Map,
    Record,
    Estimation,
    FollowUp,
  },
  data() {
    return {
      dialog: false,
      tabsItem: 0,
      tab: [
        {
          title: "แผนที่แสดงบ้านของผู้รับบริการ",
          image: require('@/assets/image/homevisit_01.svg'),
        },
        {
          title: "แบบบันทึกการเยี่ยมบ้านรายบุคคล",
          image: require('@/assets/image/homevisit_02.svg'),
        },
        {
          title: "ประเมินสภาพผู้ป่วย INHOMESSS",
          image: require('@/assets/image/homevisit_03.svg'),
        },
        {
          title: "แบบบันทึกและติดตามการเยี่ยมบ้าน",
          image: require('@/assets/image/homevisit_04.svg'),
        },
      ],
      nav: null,
      url: null,
      val: null,
    }
  },
  computed: {
    x_mobile: {
      get: function () {
        if (this.$vuetify.breakpoint.width <= 820) {
          return true;
        } else {
          return false;
        }
      },
      set: function (newValue) {
        this.nav = newValue;
      },
    },
    phone() {
      if (this.$vuetify.breakpoint.width < 450) {
        return true;
      } else {
        return false;
      }
    },
    tablet() {
      if (this.$vuetify.breakpoint.width <= 820) {
        return true;
      } else {
        return false;
      }
    },
    display_vuetify() {
      return this.$vuetify.breakpoint.name
    }
  },
  async mounted() {
    // console.log('this.item', this.item);
    // console.log('this.value',this.value);
    await this.getHomeVisitId()
  },
  methods: {
    async getHomeVisitId() {
      try {
        var params = new URLSearchParams()
        params.append('template_id', this.value.template_id)
        params.append('biz_id', sessionStorage.getItem('biz_id'))
        params.append('userqr_id', this.item.userqr_id || '')

        await this.axios.get(`${process.env.VUE_APP_BACKEND_URL}/v1/get_home_visits_byid?${params}` ,
        ).then((res) => {
          // console.log('res getHomeVisitId', res);
          if (res.data.result === "success" && res.data.code === 200) {
            if ('map_detail' in res.data.data && 'family_detail' in res.data.data && res.data.data.map_detail !== null && res.data.data.map_detail !== undefined && res.data.data.family_detail !== null && res.data.data.family_detail !== undefined) {
              this.$refs.map.openPage(res.data.data.map_detail, res.data.data.family_detail)
            }

            if ('individual_home_visits' in res.data.data && res.data.data.individual_home_visits !== null && res.data.data.individual_home_visits !== undefined) {
              this.$refs.record.openPage(this.item, res.data.data.individual_home_visits)
            } else {
              this.$refs.record.openPage(this.item, null)
            }

            if ('inhomesss' in res.data.data && res.data.data.inhomesss !== null && res.data.data.inhomesss !== undefined) {
              this.$refs.estimation.openPage(res.data.data.inhomesss)
            }

            if ('home_visit_recording' in res.data.data && res.data.data.home_visit_recording !== null && res.data.data.home_visit_recording !== undefined) {
              this.$refs.followup.openPage(this.item, this.value, res.data.data.home_visit_recording)
            } else {
              this.$refs.followup.openPage(this.item, this.value, null)
            }
            
          } else {
            this.$swal({
              title:
                "<span style='color: black;font-size: 18px;font-family: Sarabun, sans-serif;'>การดึงข้อมูลผิดพลาด</span>",
              icon: "error",
              showCloseButton: false,
              showConfirmButton: false,
              background: "white",
              timer: 3000,
            });
          }
        })
      } catch (error) {
         console.log('error', error);
      }
    },
    getData4(x) {
      console.log(x);
    },
    getData3(x) {
      console.log(x);
    },
    openDialog() {
      this.dialog = true;
      
    },
  }
}
</script>

<style scoped>
.page-size {
  overflow: auto; 
  min-height: 700px; 
  max-height: 700px;
}

::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}
</style>